import React from "react";
import TheAmphisbaena from "../translations/borges/TheAmphisbaena";
import TheLybianSerpents from "../translations/lucan/TheLybianSerpents";
import {Link} from "react-router-dom";

function Jan152023MlkDayAmphisbaenae() {
    return (
        <div className="row">
            <div className="col-md-8 offset-md-2">
                <h1 className="text-center"><Link to="/blog/mlk-day-amphisbaenae">MLK Day Amphisbaenae</Link></h1>
                <p className="text-center">2023-01-15</p>
                <hr/>
                <p>
                    This MLK day, I didn't have to log onto my computer and write code,
                    so instead I logged onto my computer and read some poems about snakes.
                </p>
                <p>
                    Here’s my translation of a text from Borges about one of Lucan’s images:
                    the double-headed amphisbaena:
                </p>
                <hr/>
                <TheAmphisbaena/>
                <hr/>
                <p>
                    Assuming his reader to be versed in the classics—or preferring to preserve an air of wonder
                    and vague mystery—Borges doesn’t provide specific references to his source texts,
                    but I was able to dig up an English version of the Pharsalia.
                </p>
                <p>
                    I went to public school in Arizona and speak not a lick of Latin, but found this text to be
                    so striking that I attempted my own re-versification of this excerpt
                    (trusting the original translator to have accurately conveyed the meaning if not
                    necessarily the movement of lines in Lucan’s original text):
                </p>
                <hr/>
                <TheLybianSerpents/>
                <hr/>
                <p>
                    … woo-wee! That was metal!
                </p>
                <p>
                    According to Tacitus, this last stanza may have also formed Lucan’s last words. When Nero
                    condemned him to commit suicide by cutting his own vein, he recalled a stanza of poetry he
                    had written about a wounded soldier who suffered a similar fate, and recited these very lines
                    just before bleeding out.
                </p>
            </div>
        </div>
    );
}

export default Jan152023MlkDayAmphisbaenae
